import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes, useLocation } from 'react-router-dom';
import axios from 'axios';
import Inicio from './pages/Inicio';
import Contabilidad from './pages/Contabilidad';
import Error404 from './components/Error404';
import Header from './components/Header';
import Footer from './components/Footer';
import IniciarSesion from './pages/IniciarSesion';
import Loader from './components/Loader';
import BASE_URL from './config/config';
import ServiciosYClientes from './pages/ServiciosYClientes';
import Empleados from './pages/Empleados';
import Proyecto from './pages/proyecto/Proyecto'; // Importa el componente Proyecto
import Ventas from './pages/Ventas';
import Perfil from './pages/Perfil';
import TareasPendientes from './pages/TareasPendientes';

const Routering = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verificarToken = async () => {
      try {
        const token = localStorage.getItem('AuthToken');
        if (!token) {
          throw new Error('No se encontró token');
        }

        const response = await axios.get(`${BASE_URL}/api/autenticacion`, {
          headers: {
            Authorization: `${token}`,
          },
        });

        console.log('Respuesta exitosa:', response.data);
        setAuthenticated(true);
      } catch (error) {
        console.error('Error al verificar el token:', error);
        setAuthenticated(false);
        localStorage.removeItem('AuthToken');
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    verificarToken();

    const handleStorageChange = (event) => {
      if (event.key === 'AuthToken') {
        verificarToken();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <Router>
      <AppContent authenticated={authenticated} loading={loading} />
    </Router>
  );
};

const AppContent = ({ authenticated, loading }) => {
  const [routeLoading, setRouteLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Solo activar el routeLoading si la ruta no es "/" y además no es una ruta de proyecto.
    if (location.pathname !== '/' && !location.pathname.startsWith('/proyecto')) {
      setRouteLoading(true);
      const timeoutId = setTimeout(() => {
        setRouteLoading(false);
      }, 500); // Ajusta el tiempo si es necesario
      return () => clearTimeout(timeoutId);
    } else {
      setRouteLoading(false);
    }
  }, [location]);

  return (
    <>
      <Header authenticated={authenticated} />
      {(loading && location.pathname !== '/') || (routeLoading && location.pathname !== '/') ? (
        <Loader />
      ) : (
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/iniciar-sesion" element={authenticated ? <Navigate to="/servicios-y-clientes" /> : <IniciarSesion />} />
          <Route path="/perfil" element={authenticated ? <Perfil /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/contabilidad" element={authenticated ? <Contabilidad /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/servicios-y-clientes" element={authenticated ? <ServiciosYClientes /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/empleados" element={authenticated ? <Empleados /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/ventas" element={authenticated ? <Ventas /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/tareas-pendientes" element={authenticated ? <TareasPendientes /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="/proyecto/:id" element={authenticated ? <Proyecto /> : <Navigate to="/iniciar-sesion" />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      )}
      <Footer />
    </>
  );
};

export default Routering;
